"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regexDataURI = exports.hasProperties = exports.noEmptySpacesValidation = void 0;
const noEmptySpacesValidation = (value) => {
    if (value && !(value.trim().length > 0)) {
        return 'Empty space is not allowed';
    }
};
exports.noEmptySpacesValidation = noEmptySpacesValidation;
const hasProperties = (message, properties) => (value) => {
    if (!value || properties.filter((property) => value[property]).length !== properties.length) {
        return message;
    }
};
exports.hasProperties = hasProperties;
exports.regexDataURI = /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@/?%\s]*)$/i;
